import { useEffect, useRef } from "react";

export const useScroll = (offsetTop = 0) => {
  const htmlElRef = useRef(null);
  const executeScroll = () =>
    window.scrollTo(0, htmlElRef.current.offsetTop - offsetTop);

  return [executeScroll, htmlElRef];
};

export const useInterval = (callback, delay) => {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => {
      savedCallback.current();
    };

    if (delay !== null) {
      let id = setInterval(tick, delay);

      return () => clearInterval(id);
    }
  }, [delay]);
};
